<div
  class="flex items-center justify-center min-h-dvh w-dvw bg-[url('/assets/images/landscapebg.jpeg')] bg-cover bg-no-repeat">
  <div
    class="w-[min(440px,calc(100%-2rem))] m-6 px-8 py-6 bg-gray-50 rounded-[1.25rem] shadow-xl min-h-[min(350px,85vh)] flex flex-col justify-center gap-4">

    <div class="flex flex-col items-center gap-4 text-center mb-4">
      <div class="flex items-center justify-center w-16 h-16 rounded-full bg-red-100">
        <lib-icon name="warning" class="text-red-400 scale-[1.33]" />
      </div>


      <div>
        <h2 class="font-semibold text-gray-800 text-xl mb-2">Ups... Algo ha salido mal</h2>
        <p class="font-body text-sm text-gray-500 leading-normal">
          Ha ocurrido un error inesperado. Si el problema persiste, contacta con el administrador.
        </p>
      </div>
    </div>


    <lib-button className="w-full"  (btnClick)="goHome()">
      <span>Volver al inicio</span>
    </lib-button>

  </div>
</div>